




















import { Component, Vue } from "vue-property-decorator";
const text =
  "蒸羊bai羔、蒸熊掌、蒸鹿尾儿、烧花鸭、烧雏鸡、烧子鹅du、卤zhi猪、卤鸭、酱鸡、腊肉、松花小dao肚儿、晾肉、香肠儿、什锦苏盘、熏鸡白肚儿、清蒸八宝猪、江米酿鸭子、罐儿野鸡、罐儿鹌鹑。";
const hover =
  "蒸羊bai羔、蒸熊掌、蒸鹿尾儿、烧花鸭、烧雏鸡、烧子鹅du、卤zhi猪、卤鸭、酱鸡、腊肉、松花小dao肚儿、晾肉、香肠儿、什锦苏盘、熏鸡白肚儿、清蒸八宝猪、江米酿鸭子、罐儿野鸡、罐儿鹌鹑。卤什件儿、卤子鹅、山鸡、兔脯、菜蟒、银鱼、清蒸哈什蚂、烩鸭丝、烩鸭腰、烩鸭条、清拌鸭丝、黄心管儿、焖白鳝、焖黄鳝、豆豉鲇鱼、锅烧鲤鱼、烀烂甲鱼、抓炒鲤鱼、抓炒对儿虾。软炸里脊、软炸鸡、什锦套肠儿、卤煮寒鸦儿、麻酥油卷儿、熘鲜蘑、熘鱼脯、熘鱼肚、熘鱼片儿、醋熘肉片儿、烩三鲜、烩白蘑、烩鸽子蛋、炒银丝、烩鳗鱼、炒白虾、炝青蛤、炒面鱼。炒竹笋、芙蓉燕菜、炒虾仁儿、烩虾仁儿、烩腰花儿、烩海参、炒蹄筋儿、锅烧海参、锅烧白菜、炸木耳、炒肝尖儿、桂花翅子、清蒸翅子、炸飞禽、炸汁儿、炸排骨、清蒸江瑶柱。";
// eslint-disable-next-line @typescript-eslint/class-name-casing
interface obj {
  pic?: string;
  hover: string;
  text: string;
}

@Component
export default class Index extends Vue {
  private imgList: Array<obj> = [];
  private picIndex = 1;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  created() {
    this.initPic();
    this.onPageScroll();
    // this.canShow();
  }
  initPic() {
    for (let index = 0; index < 10; index++) {
      this.addPic();
    }
  }
  addPic() {
    const pic = {
      text,
      hover,
      pic: require(`../../static/mingyong${this.picIndex}.png`)
    };
    this.imgList.push(pic);
    this.picIndex++;
    if (this.picIndex > 86) {
      this.picIndex = 1;
    }
  }
  canShow() {
    /** 距离显示多少px开始加载图片 */
    const distanece = 15;
    const windowHeight = window.innerHeight;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parentEl: any = document.getElementById("waterfallBox");
    const lastChild = parentEl.lastElementChild;
    const top = lastChild.getBoundingClientRect().top;
    if (top - distanece < windowHeight) {
      return true;
    } else {
      return false;
    }
  }
  onPageScroll() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    window.addEventListener("scroll", function() {
      const flag = that.canShow();
      if (flag) {
        that.addPic();
      }
    });
  }
}
